import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ApiStoreKey } from 'enums';

import { useFetchApiClassDetail } from 'modules/learners/core/hook';

import type { Classes } from '../type';

import { useFetchStore, valueByStateKeySelector } from 'hooks/service';

import { PATH } from 'constants/path';

export const useClassDetailLayoutController = () => {
  const location = useLocation();
  const navigationTo = useNavigate();

  const params = useParams();

  const { id } = params;

  const { fetchApiClassDetail } = useFetchApiClassDetail(id ?? '');

  const classes: Classes = useFetchStore(valueByStateKeySelector(ApiStoreKey.class));

  useEffect(() => {
    if (!id) {
      return;
    }

    fetchApiClassDetail();
  }, []);

  const onTabClick = (key: string) => {
    const sessionScrollPosition = JSON.parse(
      JSON.stringify(sessionStorage.getItem('scroll-position')),
    );

    if (sessionScrollPosition) sessionStorage.removeItem('scroll-position');
    navigationTo(key);
  };

  const goBack = () => {
    navigationTo(PATH.CLASSES);
  };

  return {
    locationPath: location.pathname,
    onTabClick,
    id,
    classes,
    goBack,
  };
};
